import actions from './actions';

const {
  getDailogStatusBegin,
  getDailogStatusSuccess,
  getDailogStatusErr,
  setDailogStatusBegin,
  setDailogStatusSuccess,
  setDailogStatusErr,

  getActiveLayoutBegin,
  getActiveLayoutSuccess,
  getActiveLayoutErr,
  setActiveLayoutBegin,
  setActiveLayoutSuccess,
  setActiveLayoutErr,
} = actions;

const getDailogStatusAction = () => {
  return async dispatch => {
    try {
      dispatch(getDailogStatusBegin());
      dispatch(getDailogStatusSuccess());
    } catch (err) {
      dispatch(getDailogStatusErr(err));
    }
  };
};

const setDailogStatusAction = selectedSymbol => {
  return async dispatch => {
    try {
      dispatch(setDailogStatusBegin());
      dispatch(setDailogStatusSuccess(selectedSymbol));
    } catch (err) {
      dispatch(setDailogStatusErr(err));
    }
  };
};

const getActiveLayoutAction = () => {
  return async dispatch => {
    try {
      dispatch(getActiveLayoutBegin());
      dispatch(getActiveLayoutSuccess());
    } catch (err) {
      dispatch(getActiveLayoutErr(err));
    }
  };
};

const setActiveLayoutAction = selectedSymbol => {
  return async dispatch => {
    try {
      dispatch(setActiveLayoutBegin());
      dispatch(setActiveLayoutSuccess(selectedSymbol));
    } catch (err) {
      dispatch(setActiveLayoutErr(err));
    }
  };
};

export { getDailogStatusAction, setDailogStatusAction, getActiveLayoutAction, setActiveLayoutAction };
